import { DateTime } from 'luxon'

import SATTestQ from '@/queries/SATTestQ'
import { PlatformDevice } from '@/client/services/platform/constants'
import composeRichText from '@/client/services/richText/composeRichText'
import { getSATBootcampUrl } from '@/client/services/url'
import isUserDefined from '@/client/services/user/isUserDefined'

import { makeBannerDataLoader } from './helpers'

export default makeBannerDataLoader({
  name: 'sat-bootcamp-marketing',
  load(context) {
    // Default to bannerSATBootcamp if a user is logged in
    if (isUserDefined(context.user)) {
      return null
    }

    const upcomingTest = context.query.one(
      SATTestQ.where({ limit: 1 }, SATTestQ.learnersCanRegister())
    )

    if (upcomingTest == null) {
      return null
    }

    const upcomingTestDate = DateTime.fromISO(`${upcomingTest(SATTestQ.test_date)}`)

    const bannerIdMonth = upcomingTestDate.toFormat('LLL').toLowerCase()
    const bannerIdYear = upcomingTestDate.year

    const bannerSlug = `sat-bootcamp-${bannerIdMonth}-${bannerIdYear}`

    if (context.user.platformDevice === PlatformDevice.DESKTOP) {
      return {
        slug: bannerSlug,
        content: composeRichText(ctx =>
          ctx.paragraph(
            'Preparing for your next SAT? Sign up for a free 4-week SAT Bootcamp. ',
            ctx.linkInternal(getSATBootcampUrl(), 'Learn More')
          )
        ),
      }
    }

    return {
      slug: bannerSlug,
      content: composeRichText(ctx =>
        ctx.paragraph(
          'Studying for the SAT? ',
          ctx.linkInternal(getSATBootcampUrl(), 'Sign up'),
          ' for a free 4-week SAT Bootcamp.'
        )
      ),
    }
  },
})
